var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from "react";
import Spinner from "react-bootstrap/Spinner";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Card from 'react-bootstrap/Card';
var default_1 = /** @class */ (function (_super) {
    __extends(default_1, _super);
    function default_1() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    default_1.prototype.render = function () {
        return React.createElement(React.Fragment, null,
            React.createElement(Card, null,
                React.createElement(Card.Body, null,
                    React.createElement(Row, null,
                        React.createElement(Col, { xs: "auto" },
                            React.createElement(Spinner, { animation: "border", variant: "info" })),
                        React.createElement(Col, { className: "py-1" }, "Loading quotation...")))));
    };
    return default_1;
}(React.Component));
export default default_1;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiTG9hZGluZy5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIkxvYWRpbmcudHN4Il0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7Ozs7Ozs7Ozs7Ozs7QUFBQSxPQUFPLEtBQUssS0FBSyxNQUFNLE9BQU8sQ0FBQztBQUMvQixPQUFPLE9BQU8sTUFBTSx5QkFBeUIsQ0FBQztBQUM5QyxPQUFPLEdBQUcsTUFBTSxxQkFBcUIsQ0FBQztBQUN0QyxPQUFPLEdBQUcsTUFBTSxxQkFBcUIsQ0FBQztBQUN0QyxPQUFPLElBQUksTUFBTSxzQkFBc0IsQ0FBQztBQUV4QztJQUE2Qiw2QkFBZTtJQUE1Qzs7SUFrQkEsQ0FBQztJQWpCQywwQkFBTSxHQUFOO1FBQ0UsT0FBTztZQUNMLG9CQUFDLElBQUk7Z0JBRUgsb0JBQUMsSUFBSSxDQUFDLElBQUk7b0JBQ1Isb0JBQUMsR0FBRzt3QkFDRixvQkFBQyxHQUFHLElBQUMsRUFBRSxFQUFDLE1BQU07NEJBQ1osb0JBQUMsT0FBTyxJQUFDLFNBQVMsRUFBQyxRQUFRLEVBQUMsT0FBTyxFQUFDLE1BQU0sR0FBRSxDQUN4Qzt3QkFDTixvQkFBQyxHQUFHLElBQUMsU0FBUyxFQUFDLE1BQU0sMkJBRWYsQ0FDRixDQUNJLENBQ1AsQ0FDTixDQUFBO0lBQ0wsQ0FBQztJQUNILGdCQUFDO0FBQUQsQ0FBQyxBQWxCRCxDQUE2QixLQUFLLENBQUMsU0FBUyxHQWtCM0MifQ==